import {forwardRef, useRef} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Toc } from './CommonFormatsToc';
import { MainContent } from './CommonFormatsMainContent';

const CommonFormatsBody = forwardRef((commonFormatsData, ref)  => {
  
  return (
    <>
      <div className="d-lg-none text-start text-break p-0 common-formats-toc-content" style={{ position: 'sticky', top: 0, zIndex: 1000}}>
        <Toc data={{commonFormatsData, isSideNav: false}} ref={ref} />
      </div>
      
      <Row className="justify-content-center w-100">
        <Col
          lg={3}
          xxl={2}
          className="d-none d-lg-block ps-3 pe-3 ms-3 me-3 p-5 text-start text-break common-formats-border-right-dashed common-formats-toc-content"
        >
          <Toc data={{commonFormatsData, isSideNav: true}} ref={ref} />
        </Col>
        
        
        <Col xxl={8} lg={7} md={12} className="ps-3 pe-3 ms-3 me-3 p-5 mb-3 text-start text-break common-formats-main-content">
          <MainContent data={commonFormatsData} ref={ref} />
        </Col>
      </Row>
    </>
  );
});
//
// function CommonFormatsBody(commonFormatsData, sectionRefs) {
//   //const sectionRefs = useRef({});
//
//   return (
//     <>
//       <div className="d-lg-none text-start text-break p-0" style={{ position: 'sticky', top: 0, zIndex: 1000}}>
//         <Toc data={commonFormatsData} sectionRefs={sectionRefs} isSideNav={false} />
//       </div>
//
//       <Row className="justify-content-center">
//         <Col
//           lg={3}
//           xxl={2}
//           className="d-none d-lg-block ps-3 pe-3 ms-3 me-3 p-5 text-start text-break common-formats-border-right-dashed"
//         >
//           <Toc data={commonFormatsData} sectionRefs={sectionRefs} isSideNav={true} />
//         </Col>
//
//
//         <Col xxl={7} lg={7} md={12} className="ps-3 pe-3 ms-3 me-3 p-5 text-start text-break">
//           <MainContent data={commonFormatsData} sectionRefs={sectionRefs} />
//         </Col>
//       </Row>
//     </>
//   );
// }

export default CommonFormatsBody;